import { useState } from 'react'
import { PALETTE, randomColor } from '../lib/identity.js'

// Name + color prompt. Used both to start/join from the landing page and to set
// identity when arriving at a room link without one stored.
export default function NameColorModal({ initial, onSubmit, onCancel, title = 'Join the map', cta = 'Continue' }) {
  const [name, setName] = useState(initial?.name || '')
  const [color, setColor] = useState(initial?.color || randomColor())

  function submit(e) {
    e.preventDefault()
    const trimmed = name.trim()
    if (!trimmed) return
    onSubmit({ name: trimmed, color })
  }

  return (
    <div className="modal-backdrop">
      <form className="modal-card" onSubmit={submit}>
        <h2>{title}</h2>
        <label className="field">
          <span>Your name</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            maxLength={24}
            placeholder="e.g. Sam"
          />
        </label>
        <div className="field">
          <span>Your color</span>
          <div className="swatches">
            {PALETTE.map((c) => (
              <button
                type="button"
                key={c}
                className={'swatch' + (c === color ? ' selected' : '')}
                style={{ background: c }}
                onClick={() => setColor(c)}
                aria-label={`Color ${c}`}
              />
            ))}
          </div>
        </div>
        <div className="modal-actions">
          {onCancel && (
            <button type="button" className="btn-ghost" onClick={onCancel}>
              Back
            </button>
          )}
          <button type="submit" className="btn-primary" disabled={!name.trim()}>
            {cta}
          </button>
        </div>
      </form>
    </div>
  )
}
